import { Enum } from '@examdojo/supabase';

export type StudentAssignmentStatus = 'NOT_STARTED' | 'IN_PROGRESS' | 'COMPLETED';
export type StudentAssignmentDifficulty = Enum<'stem_difficulty_category'>;

export interface StudentAssignmentHttpModel {
  assignment_id: string | null;
  assignment_name: string | null;
  student_id: string | null;
  class_id: string | null;
  homework_activity_id: string | null;
  scheduled_at: string | null;
  due_at: string | null;
  homework_status: string | null;
  submitted_at: string | null;
  awarded_marks: number | null;
  total_marks: number | null;
  difficulty?: string | null;
  key_observations?: string | null;
}

export interface StudentAssignmentUIModel {
  assignmentId: string;
  assignmentName: string;
  studentId: string;
  classId: string;
  homeworkActivityId: string | null;
  scheduledAt: string | null;
  dueAt: string | null;
  status: StudentAssignmentStatus;
  submittedAt: string | null;
  awardedMarks: number | null;
  totalMarks: number;
  scorePercent: number | null;
  difficulty: StudentAssignmentDifficulty | null;
  keyObservations: string | null;
}

export function mapStudentAssignmentToUIModel(row: StudentAssignmentHttpModel): StudentAssignmentUIModel {
  const status: StudentAssignmentStatus =
    row.homework_status === 'COMPLETED'
      ? 'COMPLETED'
      : row.homework_status === 'IN_PROGRESS'
        ? 'IN_PROGRESS'
        : 'NOT_STARTED';

  const totalMarks = row.total_marks ?? 0;
  const awardedMarks = status === 'COMPLETED' ? (row.awarded_marks ?? null) : null;
  const scorePercent = awardedMarks !== null && totalMarks > 0 ? (awardedMarks / totalMarks) * 100 : null;

  return {
    assignmentId: row.assignment_id ?? '',
    assignmentName: row.assignment_name ?? '',
    studentId: row.student_id ?? '',
    classId: row.class_id ?? '',
    homeworkActivityId: row.homework_activity_id ?? null,
    scheduledAt: row.scheduled_at,
    dueAt: row.due_at,
    status,
    submittedAt: row.submitted_at,
    awardedMarks,
    totalMarks,
    scorePercent,
    difficulty: toDifficulty(row.difficulty),
    keyObservations: row.key_observations ?? null,
  };
}

function toDifficulty(value: string | null | undefined): StudentAssignmentDifficulty | null {
  if (value === 'EASY' || value === 'MEDIUM' || value === 'HARD') {
    return value;
  }

  return null;
}
